
module.exports = {
    handle: (e, data) => {
        if (!data) {
            return;
        }

        const {gtmProducts, gtmDetails} = data;

        if (!gtmProducts || ! gtmDetails) {
            return;
        }

        let objProducts, objDetails = [];

        try {
            objProducts = JSON.parse(gtmProducts) || [];
            objDetails = JSON.parse(gtmDetails) || [];
        } catch(e) {
            return;
        }

        const { customerId, emailAddress } = objDetails;
        const newProducts = [];

        objProducts.forEach((element) => {
            newProducts.push({
                'item_name' : element.name,
                'item_id' : element.id,
                'price' : element.price,
                'item_brand' : element.brand,
                'item_category' : element.category,
                'quantity' : element.quantity
            });
        });

        const beginCheckoutData = {
            event: 'begin_checkout',
            currency :'CLP',
            value : objDetails.grandTotal,
            items: newProducts
        };

        customerId ? beginCheckoutData.userId = customerId : null;
        emailAddress ? beginCheckoutData.email = emailAddress : null;

        dataLayer.push(beginCheckoutData);
    }
}